import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { extractElement } from "../../../util";
import { positions, colors, icons } from "../../../enums";
import { whitelistStyles } from "../../core/hoc";
import { PrivateMenuItem } from "../../core/menu/menu-item";
import Icon from "../../core/icon"; // <PopupMenu.Item
//   type='cta'
//   text='Experience >'
//   byline='Create a new'
//   detail='detail text'
//   icon='browser'
//   color={colors.SUPER}
//   onClick={myHandler}
// />

var popupMenuItemTypes = {
  CTA: 'cta',
  HEADER: 'header',
  NONE: 'none'
};
popupMenuItemTypes.HEADER_TYPES = [popupMenuItemTypes.CTA, popupMenuItemTypes.HEADER];
popupMenuItemTypes.ALL = _valuesInstanceProperty(_).call(_, popupMenuItemTypes);
var PopupMenuItem = createComponent({
  displayName: 'PopupMenuItem',
  propTypes: {
    type: PropTypes.oneOf(popupMenuItemTypes.ALL),
    icon: PropTypes.oneOfType([PropTypes.oneOf(icons.ALL), PropTypes.element]),
    text: PropTypes.string,
    byline: PropTypes.string,
    detail: PropTypes.string,
    color: PropTypes.oneOf(colors.CORE),
    onClick: PropTypes.func
  },
  defaultProps: {
    type: popupMenuItemTypes.NONE,
    icon: null,
    text: null,
    byline: null,
    detail: null,
    color: undefined,
    onClick: null
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var icon = extractElement(Icon, p.icon, 'name');
    logger.warn('PopupMenuItem: Must contain at least one content property, icon, text, byline, or detail.', !p.icon && !p.text && !p.detail && !p.byline);
    var color = p.color;
    if (itemIsHeader(p.type) && !p.color) color = colors.ACCENT;
    return /*#__PURE__*/React.createElement(PrivateMenuItem, {
      color: color,
      isHeader: itemIsHeader(p.type),
      onClick: p.onClick,
      value: p.value,
      style: p.style
    }, /*#__PURE__*/React.createElement("div", null, !!icon ? icon.element : null, itemIsHeader(p.type) ? /*#__PURE__*/React.createElement("div", {
      className: classnames("ck-popup-menu-" + p.type)
    }, p.type === popupMenuItemTypes.CTA && !!p.byline ? /*#__PURE__*/React.createElement("div", {
      className: "ck-popup-menu-byline"
    }, p.byline) : null, /*#__PURE__*/React.createElement("div", {
      className: "ck-popup-menu-text"
    }, p.text), p.type === popupMenuItemTypes.HEADER && !!p.byline ? /*#__PURE__*/React.createElement("div", {
      className: "ck-popup-menu-byline"
    }, p.byline) : null, p.type === popupMenuItemTypes.HEADER && !!p.detail ? /*#__PURE__*/React.createElement("div", {
      className: "ck-popup-menu-detail"
    }, p.detail) : null) : p.text));
  }
});

function itemIsHeader(type) {
  return _includesInstanceProperty(_).call(_, popupMenuItemTypes.HEADER_TYPES, type);
}

export default whitelistStyles()(PopupMenuItem);
//# sourceMappingURL=popup-menu-item.js.map